// extracted by mini-css-extract-plugin
export default {"title":"telepon-pemilik-properti_title__wcC9u"};